<template>
  <v-container class="sign-up-choice align-start" fluid fill-height>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="2" md="6" offset-md="3" xl="4" offset-xl="4" align="center">
        <v-card>
          <v-row class="primary ma-0">
            <v-col cols="12">
              <a @click="goToPath('/')">
                <v-img height="auto" width="100" src="@/assets/zf-logo-white-cirle.png"/>
              </a>
            </v-col>
          </v-row>

          <v-row class="">
            <v-col cols="12" class="primary--text">
              <p class="my-2">
                Select the type of account you want to create:
              </p>
              <v-btn class="ma-2 farmer_teal white--text" to="/sign-up/customer">Register as customer</v-btn>
              <v-btn class="ma-2 primary" to="/sign-up/supplier">Register as  Supplier</v-btn>
            </v-col>
          </v-row>

          <router-view></router-view>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.sign-up-choice {
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6)),
    url('../../../assets/about/rwanda-farmer.jpg');
  background-repeat: repeat;
}
</style>
